export default __webpack_public_path__ + "static/media/handsonmobile.3a9c5da3.jpg";